export enum InitializationState {
	IDLE = "IDLE",
	PENDING = "PENDING",
	FINISHED = "FINISHED",
}
